/**
 * Geocoding utility using Nominatim (OpenStreetMap)
 */

export interface ReverseGeocodeResult {
	city: string;
	state: string;
	country: string;
	formatted_address?: string;
	address_parts?: string[];
}

/**
 * Reverse geocodes coordinates to a human-readable address.
 * Uses Nominatim (OpenStreetMap) to avoid Google Maps Billing issues.
 *
 * @param lat Latitude
 * @param lng Longitude
 * @returns Promise<ReverseGeocodeResult>
 */
export const reverseGeocode = async (lat: number | string, lng: number | string): Promise<ReverseGeocodeResult> => {
	try {
		// Nominatim usage policy requires a User-Agent
		const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`, {
			headers: {
				'User-Agent': 'BReporter-Website/1.0',
			},
		});

		if (!response.ok) {
			throw new Error(`Nominatim error: ${response.status}`);
		}

		const data = await response.json();
		const address = data.address || {};

		return {
			city: address.city || address.town || address.village || address.suburb || '',
			state: address.state || '',
			country: address.country || '',
			formatted_address: data.display_name || '',
			address_parts: data.display_name ? data.display_name.split(',').map((p: string) => p.trim()) : [],
		};
	} catch (error) {
		console.error('Reverse geocoding failed:', error);
		return {
			city: '',
			state: '',
			country: '',
		};
	}
};
